module.exports = __webpack_public_path__ + "media/Salam,Peace,Heiwa.369a8462.mp3";